import ms from 'ms'

export const NOTIFICATION_TIMEOUT = ms('5s')
export const NOTIFICATION_TYPES = ['success', 'warning', 'error', 'info']
